var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBrainCanadaWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 280 80",
    style: {
      enableBackground: "new 0 0 280 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#009FE3;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52-0.4c-28.7,0-52,23.3-52,52c0,15.9,12.9,28.9,28.9,28.9c15.9,0,28.9-13,28.9-28.9c0-3.2-2.6-5.8-5.8-5.8 c-3.2,0-5.8,2.6-5.8,5.8c0,9.6-7.8,17.3-17.3,17.3c-9.6,0-17.3-7.8-17.3-17.3c0-22.3,18.1-40.4,40.4-40.4 c22.3,0,40.4,18.1,40.4,40.4c0,3.2,2.6,5.8,5.8,5.8c3.2,0,5.8-2.6,5.8-5.8C104,22.9,80.6-0.4,52-0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52,22.7c-15.9,0-28.9,13-28.9,28.9c0,3.2,2.6,5.8,5.8,5.8c3.2,0,5.8-2.6,5.8-5.8c0-9.6,7.8-17.3,17.3-17.3 c9.6,0,17.3,7.8,17.3,17.3c0,3.2,2.6,5.8,5.8,5.8c3.2,0,5.8-2.6,5.8-5.8C80.9,35.6,67.9,22.7,52,22.7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "125.6,26.7 132.5,26.7 132.5,24.5 125.6,24.5 125.6,20.4 133.5,20.4 133.5,18.1 122.9,18.1  122.9,33.5 125.6,33.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M139.9,33.8c3.6,0,5.6-2.5,5.6-5.9c0-3.4-2-5.9-5.6-5.9c-3.6,0-5.6,2.5-5.6,5.9 C134.3,31.3,136.4,33.8,139.9,33.8z M139.9,24c2.2,0,3.2,2,3.2,3.9c0,1.9-1,3.9-3.2,3.9c-2.2,0-3.2-2-3.2-3.9 C136.8,26,137.7,24,139.9,24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.6,26.9c0-1.6,1.1-2.9,2.7-2.9c1.4,0,2.1,0.8,2.2,2.5v7h2.5v-7.6c0-2.5-1.5-3.8-3.9-3.8 c-1.5,0-2.7,0.8-3.5,2l0,0v-1.6h-2.3v11.1h2.5V26.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M163.7,33.8c1.4,0,2.8-0.5,3.4-1.8h0v1.5h2.3V18.1h-2.5v5.7h0c-0.8-1.2-2.3-1.7-3.7-1.7 c-2.4,0-4.8,1.8-4.8,5.8C158.5,31.2,160.2,33.8,163.7,33.8z M164.1,24c1.9,0,3.1,1.5,3.1,3.9c0,1.9-0.9,3.9-3.1,3.9 c-2.1,0-3.1-1.9-3.1-3.8C161,26,161.8,24,164.1,24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M181.1,31v-5.7c0-2.3-2.3-3.2-4.5-3.2c-2.5,0-4.9,0.8-5.1,3.7h2.5c0.1-1.2,1.1-1.8,2.5-1.8 c1,0,2.3,0.2,2.3,1.5c0,1.4-1.6,1.2-3.3,1.6c-2.1,0.2-4.3,0.7-4.3,3.5c0,2.2,1.8,3.2,3.8,3.2c1.3,0,2.9-0.4,3.8-1.4 c0.2,1,0.9,1.4,1.9,1.4c0.4,0,1.2-0.2,1.5-0.3v-1.7c-0.3,0-0.5,0-0.6,0C181.2,31.8,181.1,31.6,181.1,31z M178.7,29.7 c0,1.6-1.7,2.1-2.8,2.1c-0.9,0-2.3-0.3-2.3-1.4c0-1.3,0.9-1.7,2-1.8c1.1-0.2,2.3-0.2,3-0.7V29.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M184.1,30.7c0,1.9,0.5,2.8,3.1,2.8c0.5,0,1.1-0.1,1.6-0.1v-1.9c-0.3,0.1-0.7,0.1-1,0.1c-1.1,0-1.2-0.5-1.2-1.5 v-5.9h2.2v-1.8h-2.2V19h-2.5v3.3h-1.9v1.8h1.9V30.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.1,
    y: 18.1,
    className: "st1",
    width: 2.5,
    height: 2.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.1,
    y: 22.4,
    className: "st1",
    width: 2.5,
    height: 11.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M199.9,33.8c3.6,0,5.6-2.5,5.6-5.9c0-3.4-2-5.9-5.6-5.9c-3.6,0-5.6,2.5-5.6,5.9 C194.3,31.3,196.3,33.8,199.9,33.8z M199.9,24c2.2,0,3.2,2,3.2,3.9c0,1.9-1,3.9-3.2,3.9c-2.2,0-3.2-2-3.2-3.9 C196.7,26,197.7,24,199.9,24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M209.6,26.9c0-1.6,1.1-2.9,2.7-2.9c1.4,0,2.1,0.8,2.2,2.5v7h2.5v-7.6c0-2.5-1.5-3.8-3.9-3.8 c-1.5,0-2.7,0.8-3.5,2l0,0v-1.6h-2.3v11.1h2.5V26.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M137.6,43.1c0-3.1-2.2-4.7-5.6-4.7h-9.1v18.8h8.6c4.9,0,6.9-2.3,6.9-5.2c0-2.6-1.2-4.3-3.5-4.8v-0.1 C136.6,46.4,137.6,45,137.6,43.1z M126.2,41.1h5.4c1.8,0,2.8,0.7,2.8,2.6c0,1.7-1.2,2.6-2.8,2.6h-5.4V41.1z M135.2,51.6 c0,1.9-1.2,3-3.2,3h-5.8v-5.9h5.8C134,48.7,135.2,49.7,135.2,51.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M148.4,43.4c-0.3,0-0.4-0.1-1.1-0.1c-1.8,0-3.6,1.6-4,3h-0.1v-2.6h-2.8v13.6h3v-6.5c0-3,1.6-4.7,3.7-4.7 c0.4,0,0.9,0.1,1.3,0.1V43.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M162,57.3v-2.1c-0.3,0.1-0.6,0.1-0.7,0.1c-0.6,0-0.7-0.3-0.7-1v-7c0-2.9-2.8-3.9-5.4-3.9c-3,0-6,1-6.2,4.5h3 c0.1-1.5,1.3-2.2,3-2.2c1.2,0,2.8,0.3,2.8,1.8c0,1.8-1.9,1.5-4.1,1.9c-2.5,0.3-5.2,0.8-5.2,4.2c0,2.7,2.2,4,4.7,4 c1.6,0,3.5-0.5,4.7-1.7c0.2,1.2,1.1,1.7,2.3,1.7C160.6,57.6,161.6,57.4,162,57.3z M157.6,52.7c0,1.9-2.1,2.6-3.4,2.6 c-1.1,0-2.8-0.4-2.8-1.7c0-1.6,1.2-2.1,2.4-2.3c1.3-0.2,2.8-0.2,3.7-0.8V52.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.4,
    y: 38.5,
    className: "st1",
    width: 3,
    height: 2.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.4,
    y: 43.6,
    className: "st1",
    width: 3,
    height: 13.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M172.1,49.2c0-2,1.3-3.6,3.3-3.6c1.8,0,2.6,0.9,2.7,3.1v8.5h3v-9.3c0-3.1-1.9-4.6-4.8-4.6 c-1.8,0-3.3,0.9-4.2,2.4l-0.1-0.1v-2h-2.8v13.6h3V49.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M198.9,57.7c4.5,0,7.7-3.1,8-7.6h-3.2c-0.3,2.7-1.9,4.9-4.8,4.9c-4,0-5.7-3.5-5.7-7.2s1.7-7.2,5.7-7.2 c2.7,0,4.1,1.6,4.7,3.7h3.3c-0.4-4-3.7-6.4-8-6.4c-5.6,0-9,4.5-9,9.8C189.9,53.2,193.2,57.7,198.9,57.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M221.7,57.3v-2.1c-0.3,0.1-0.6,0.1-0.7,0.1c-0.6,0-0.7-0.3-0.7-1v-7c0-2.9-2.8-3.9-5.4-3.9c-3,0-6,1-6.2,4.5h3 c0.1-1.5,1.3-2.2,3-2.2c1.2,0,2.8,0.3,2.8,1.8c0,1.8-1.9,1.5-4.1,1.9c-2.5,0.3-5.2,0.8-5.2,4.2c0,2.7,2.2,4,4.7,4 c1.6,0,3.5-0.5,4.7-1.7c0.2,1.2,1.1,1.7,2.3,1.7C220.3,57.6,221.3,57.4,221.7,57.3z M217.3,52.7c0,1.9-2.1,2.6-3.4,2.6 c-1.1,0-2.8-0.4-2.8-1.7c0-1.6,1.2-2.1,2.4-2.3c1.3-0.2,2.8-0.2,3.7-0.8V52.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M230.1,43.3c-1.8,0-3.3,0.9-4.2,2.4l-0.1-0.1v-2H223v13.6h3v-8c0-2,1.3-3.6,3.3-3.6c1.8,0,2.6,0.9,2.7,3.1v8.5 h3v-9.3C234.9,44.8,233.1,43.3,230.1,43.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M248.9,54.2v-7c0-2.9-2.8-3.9-5.4-3.9c-3,0-6,1-6.2,4.5h3c0.1-1.5,1.3-2.2,3-2.2c1.2,0,2.8,0.3,2.8,1.8 c0,1.8-1.9,1.5-4.1,1.9c-2.5,0.3-5.2,0.8-5.2,4.2c0,2.7,2.2,4,4.7,4c1.6,0,3.5-0.5,4.7-1.7c0.2,1.2,1.1,1.7,2.3,1.7 c0.5,0,1.4-0.2,1.9-0.3v-2.1c-0.3,0.1-0.6,0.1-0.7,0.1C249.1,55.2,248.9,54.9,248.9,54.2z M245.9,52.7c0,1.9-2.1,2.6-3.4,2.6 c-1.1,0-2.8-0.4-2.8-1.7c0-1.6,1.2-2.1,2.4-2.3c1.3-0.2,2.8-0.2,3.7-0.8V52.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M261.4,45.4L261.4,45.4c-1-1.5-2.9-2.1-4.6-2.1c-3,0-5.9,2.2-5.9,7.1c0,4.1,2.1,7.3,6.4,7.3 c1.7,0,3.4-0.7,4.2-2.2h0.1v1.8h2.8V38.5h-3V45.4z M257.7,55.2c-2.6,0-3.8-2.3-3.8-4.7c0-2.4,1-4.9,3.8-4.9c2.3,0,3.8,1.8,3.8,4.8 C261.5,52.8,260.4,55.2,257.7,55.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M279.3,55.2c-0.6,0-0.7-0.3-0.7-1v-7c0-2.9-2.8-3.9-5.4-3.9c-3,0-6,1-6.2,4.5h3c0.1-1.5,1.3-2.2,3-2.2 c1.2,0,2.8,0.3,2.8,1.8c0,1.8-1.9,1.5-4.1,1.9c-2.5,0.3-5.2,0.8-5.2,4.2c0,2.7,2.2,4,4.7,4c1.6,0,3.5-0.5,4.7-1.7 c0.2,1.2,1.1,1.7,2.3,1.7c0.5,0,1.4-0.2,1.9-0.3v-2.1C279.7,55.2,279.4,55.2,279.3,55.2z M275.6,52.7c0,1.9-2.1,2.6-3.4,2.6 c-1.1,0-2.8-0.4-2.8-1.7c0-1.6,1.2-2.1,2.4-2.3c1.3-0.2,2.8-0.2,3.7-0.8V52.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "122.9,77.7 125.6,77.7 125.6,70.9 132.5,70.9 132.5,68.7 125.6,68.7 125.6,64.6 133.5,64.6  133.5,62.3 122.9,62.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M139.9,66.3c-3.6,0-5.6,2.5-5.6,5.9c0,3.4,2,5.9,5.6,5.9c3.6,0,5.6-2.5,5.6-5.9 C145.6,68.7,143.5,66.3,139.9,66.3z M139.9,76c-2.2,0-3.2-2-3.2-3.9c0-1.9,1-3.9,3.2-3.9c2.2,0,3.2,2,3.2,3.9 C143.1,74,142.1,76,139.9,76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M154.5,73c0,1.7-0.7,3-2.7,3c-1.3,0-2.1-0.7-2.1-2.7v-6.8h-2.5v7.1c0,2.9,1.2,4.4,4.2,4.4 c1.2,0,2.6-0.7,3.2-1.9h0v1.6h2.4V66.6h-2.5V73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M164.9,66.3c-1.5,0-2.7,0.8-3.5,2l0,0v-1.6h-2.3v11.1h2.5v-6.6c0-1.6,1.1-2.9,2.7-2.9c1.4,0,2.1,0.8,2.2,2.5v7 h2.5V70C168.8,67.5,167.3,66.3,164.9,66.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M179,68L179,68c-0.8-1.2-2.3-1.7-3.7-1.7c-2.4,0-4.8,1.8-4.8,5.8c0,3.3,1.7,5.9,5.2,5.9c1.4,0,2.8-0.5,3.4-1.8 h0v1.5h2.3V62.3H179V68z M176,76c-2.1,0-3.1-1.9-3.1-3.8c0-2,0.8-4,3.1-4c1.9,0,3.1,1.5,3.1,3.9C179.1,74,178.2,76,176,76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M193,75.2v-5.7c0-2.3-2.3-3.2-4.5-3.2c-2.5,0-4.9,0.8-5.1,3.7h2.5c0.1-1.2,1.1-1.8,2.5-1.8 c1,0,2.3,0.2,2.3,1.5c0,1.4-1.6,1.2-3.3,1.6c-2.1,0.2-4.3,0.7-4.3,3.5c0,2.2,1.8,3.2,3.8,3.2c1.3,0,2.9-0.4,3.9-1.4 c0.2,1,0.9,1.4,1.9,1.4c0.4,0,1.2-0.2,1.5-0.3V76c-0.3,0-0.5,0-0.6,0C193.1,76,193,75.8,193,75.2z M190.6,73.9 c0,1.6-1.7,2.1-2.8,2.1c-0.9,0-2.3-0.3-2.3-1.4c0-1.3,0.9-1.7,2-1.8c1.1-0.2,2.3-0.2,3-0.7V73.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M198.4,63.2H196v3.3h-1.9v1.8h1.9v6.6c0,1.9,0.5,2.8,3.1,2.8c0.5,0,1.1-0.1,1.6-0.1v-1.9 c-0.3,0.1-0.7,0.1-1,0.1c-1.1,0-1.2-0.5-1.2-1.5v-5.9h2.2v-1.8h-2.2V63.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 62.3,
    className: "st1",
    width: 2.5,
    height: 2.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 66.6,
    className: "st1",
    width: 2.5,
    height: 11.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M211.8,66.3c-3.6,0-5.6,2.5-5.6,5.9c0,3.4,2,5.9,5.6,5.9c3.6,0,5.6-2.5,5.6-5.9 C217.4,68.7,215.4,66.3,211.8,66.3z M211.8,76c-2.2,0-3.2-2-3.2-3.9c0-1.9,1-3.9,3.2-3.9c2.2,0,3.2,2,3.2,3.9 C215,74,214,76,211.8,76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M224.9,66.3c-1.5,0-2.7,0.8-3.5,2l0,0v-1.6H219v11.1h2.5v-6.6c0-1.6,1.1-2.9,2.7-2.9c1.4,0,2.1,0.8,2.2,2.5v7 h2.5V70C228.8,67.5,227.3,66.3,224.9,66.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBrainCanadaWhite);
export default __webpack_public_path__ + "static/media/logo-brain-canada-white.44bcba61d04ff1f28f7e6642ba0a8ad0.svg";
export { ForwardRef as ReactComponent };